import React from "react";
import Header from "../../Components/Header";
import Category from "../../Components/Category";
import CategoryHeading from "../../Components/CategoryHeading";
import Card from "../../Components/Card";
import Image from "../../Assets/Images/Timer/Analog Timer.png";
import Image1 from "../../Assets/Images/Timer/Digital Timer.png";
import Footer from "../../Components/Footer/indes";
import "./Timer.css";

function Timer() {
  return (
    <>
      <div style={{ height: 80 }}>
        <Header />
      </div>
      <Category />
      <CategoryHeading Title={"Our Timer"} />

      <div className="my-cards">
        <Card Image={Image} Title={"Analog Timer"} />
        <Card Image={Image1} Title={"Digital Timer"} />
      </div>
      <div className="footer">
        <Footer />
      </div>
    </>
  );
}

export default Timer;
